import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { LeaseAgreementCategory } from '../../../rent/model/const/enums';

@Component({
    selector: 'app-invoices-overview',
    templateUrl: './invoices-overview.component.html',
    styleUrls: ['./invoices-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InvoicesOverviewComponent implements OnInit {
  constructor() {}

  @Input() dataContext: any;

  get dwelling(): LeaseAgreementCategory {
    return LeaseAgreementCategory.Dwelling;
  }
  get other(): LeaseAgreementCategory {
    return LeaseAgreementCategory.Other;
  }
  get parking(): LeaseAgreementCategory {
    return LeaseAgreementCategory.Parking;
  }
  get premises(): LeaseAgreementCategory {
    return LeaseAgreementCategory.Premises;
  }

  get cooperativeHousing(): LeaseAgreementCategory {
    return LeaseAgreementCategory.CooperativeHousing;
  }

  get block(): LeaseAgreementCategory {
    return LeaseAgreementCategory.Block;
  }

  ngOnInit() {}
}
